export const CONTRACT_ID_CUSTOM_FIELD = '138bb13f-ec96-484e-b6be-8702856a1250'
